// extracted by mini-css-extract-plugin
export var big = "styles-module--big--19b50";
export var button = "styles-module--button--ca165";
export var defaultButton = "styles-module--defaultButton--33c44";
export var primary = "styles-module--primary--6ab22";
export var secondary = "styles-module--secondary--80fa4";
export var small = "styles-module--small--92f25";